module.exports = __webpack_public_path__ + "static/img/red_01_557.56aa71d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/red_01_557.png
// module id = bd+a
// module chunks = 0